module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    staticClass: "mdl-dialog"
  }, [(_vm.title) ? _c('h4', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "mdl-dialog__content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [(_vm.onAccept) ? _c('ui-button', {
    attrs: {
      "raised": "",
      "primary": "",
      "disabled": _vm.disabledAccept
    },
    nativeOn: {
      "click": function($event) {
        _vm.accept($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.acceptText))]) : _vm._e(), _vm._v(" "), _c('ui-button', {
    attrs: {
      "disabled": _vm.disabledAccept
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c9502c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiDialog.vue
// module id = 268
// module chunks = 2